<template>
  <div class="news-page">
    <div class="news-page-header">
      <div class="header-search" ref="headerSearchEl">
        <el-input
          :placeholder="$t('home.please_input')"
          v-model="val"
          @keyup.enter.native="searchText"
        ></el-input>
        <i class="iconfont icon-sousuo" @click="searchText"></i>
      </div>
      <div class="header-navigation-container" ref="headerNavigationContainerEl">
        <div class="header-navigation">
          <div class="header-navigation-left" ref="headerNavigationLeftEl">
            <span @click="onAll()" :class="route.includes('all') ? 'active' : ''">{{$t('home.all')}}</span>
            <span
              v-for="item in typeList"
              :key="item.id"
              @click="toPage(item)"
              :class="route.includes(item.typeName) ? 'active' : ''"
            >{{$getConfigText(item.typeName)}}</span>
          </div>
          <div class="header-navigation-right" ref="headerNavigationRightEl">
            <el-input
              :placeholder="$t('home.please_input')"
              v-model="val"
              @keyup.enter.native="searchText"
            ></el-input>
            <i class="iconfont icon-sousuo" @click="searchText"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="news-page-content">
      <news-content ref="newsContent" :route="route" :searchList="searchList" :allList="newsList"></news-content>
    </div>
  </div>
</template>

<script>
import { News } from "@/models/news.js";
import newsContent from "@/components/news/content.vue";

export default {
  name: "home_news",
  data() {
    return {
      route: "all",
      val: "",
      searchList: [],
      typeList: [],
      originList: [],
      newsList: [],
      linshi: {},
      filterList: [],
      tempList: []
    };
  },
  components: {
    newsContent
  },
  methods: {
    init(tempList) {
      News.getNewsType().then(res => {
        this.typeList = res.sort((a, b) => {
          return a.sort - b.sort
        });
        News.getNewsList().then(res => {
          this.originList = res;
          if (tempList && tempList.length > 0) {
            this.newsList = tempList;
          } else {
            this.newsList = res;
          };
          this.typeList.forEach(e => {
            this.linshi[e.id] = [];
            this.newsList.forEach(a => {
              if (e.id === a.type) {
                this.linshi[e.id].push(a);
                a.bgColor = e.bgColor;
                a.fontColor = e.fontColora;
                a.typeName = e.typeName;
              }
            });
          });
        });
      });
    },
    onAll() {
      this.$refs.newsContent.isShowEmptyContent = false;
      this.route = "all";
      this.init();
      this.searchList = [];
    },
    toPage(item) {
      this.$refs.newsContent.isShowEmptyContent = false;
      this.route = item.typeName;
      this.filterList = this.linshi[item.id];
      this.newsList = this.filterList;
      this.$refs.newsContent.isShowEmptyContent = this.newsList.length === 0;
    },
    searchText() {
      this.newsList = this.originList;
      let searchList = [];
      if (this.val != "") {
        this.newsList.forEach(item => {
          if (item.title.indexOf(this.val) != -1) {
            searchList.push(item);
          }
        });
        if (searchList.length == 0) {
          this.$refs.newsContent.isShowNullInfo = true;
        } else {
          this.searchList = searchList;
          this.$refs.newsContent.isShowNullInfo = false;
        }
      } else {
        this.searchList = this.newsList;
        this.$refs.newsContent.isShowNullInfo = false;
        if (!window.location.href.endsWith("/news")) {
          this.$router.replace("/news");
        }
      }
      this.newsList = this.searchList;
      this.route = "all";
      this.$refs.newsContent.currentPage = 1;
    },
    scrollE() {
      let headerSearchElBottom = this.$refs.headerSearchEl.getBoundingClientRect()
        .bottom;
      let scrollTop = document.documentElement.scrollTop;
      if (scrollTop - headerSearchElBottom > 48) {
        this.$refs.headerNavigationContainerEl.classList.add("active");
        this.$refs.headerNavigationLeftEl.classList.add("active");
        this.$refs.headerNavigationRightEl.classList.add("active");
      } else {
        this.$refs.headerNavigationContainerEl.classList.remove("active");
        this.$refs.headerNavigationLeftEl.classList.remove("active");
        this.$refs.headerNavigationRightEl.classList.remove("active");
      }
    }
  },
  created() {
    if (this.$route.params.tempList) {
      this.init(this.$route.params.tempList);
    } else {
      this.init();
    }

    this.route = this.$route.params.route ? this.$route.params.route : "all";
  },
  mounted() {
    window.addEventListener("scroll", this.scrollE);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.scrollE);
  }
};
</script>

<style lang="scss" scoped>
.news-page {
  width: 100%;
  .news-page-header {
    width: 100%;
    height: 200px;
    position: relative;
    left: 0;
    right: 0;
    margin: auto;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    background-image: url(https://credamo-imgfile.oss-cn-beijing.aliyuncs.com/profile/upload/1620202000964.jpg);
    .header-search {
      width: 1100px;
      position: relative;
      left: 0;
      right: 0;
      z-index: 10;
      margin: auto;
      padding-top: 70px;
      padding-bottom: 30px;
      text-align: center;
      .el-input {
        width: 600px;
      }
      i {
        font-weight: bold;
        font-size: 20px;
        width: 50px;
        line-height: 40px;
        position: absolute;
        top: 70px;
        left: calc(50% + 250px);
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
        cursor: pointer;
        color: #02a7f0;
        background-color: rgba(242, 242, 242, 0.6);
      }
    }
    .header-navigation-container {
      position: relative;
      z-index: 10;
      height: 60px;
      width: 100%;
      .header-navigation {
        width: 1100px;
        height: 100%;
        display: flex;
        align-items: center;
        position: absolute;
        left: 0;
        right: 0;
        margin: auto;
        overflow: hidden;
        div.header-navigation-left {
          display: inline-block;
          position: relative;
          left: 250px;
          span {
            display: inline-block;
            position: relative;
            font-size: 15px;
            line-height: 40px;
            height: 40px;
            cursor: pointer;
            margin-right: 30px;
            color: white;
            &::after {
              content: "";
              width: 100%;
              height: 2px;
              position: absolute;
              bottom: -12px;
              left: 0;
              transition: all 0.3s;
              background: white;
            }
            &:hover::after {
              bottom: -2px;
            }
            &.active::after {
              bottom: -2px;
            }
          }
          &.active {
            transition: left 0.3s;
            left: 20px;
          }
        }
        div.header-navigation-right {
          position: absolute;
          right: 0;
          top: 0;
          line-height: 60px;
          transform: translateX(100%);
          .el-input {
            width: 240px;
            height: 30px;
          }
          .el-input >>> .el-input__inner {
            line-height: 30px;
            height: 30px;
          }
          i {
            font-size: 18px;
            font-weight: bold;
            position: absolute;
            right: 0;
            top: 15px;
            text-align: center;
            width: 40px;
            line-height: 30px;
            border-top-right-radius: 4px;
            border-bottom-right-radius: 4px;
            cursor: pointer;
            color: #02a7f0;
            background-color: rgba(242, 242, 242, 0.6);
          }
          &.active {
            transition: all 0.3s;
            transform: translateX(0);
          }
        }
      }
      &.active {
        position: fixed;
        top: 80px;
        background-color: rgb(8, 70, 179);
      }
    }
    &::after {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(19, 78, 181, 0.537254901960784);
    }
  }
  // 内容样式
  .news-page-content {
    display: flex;
    justify-content: center;
  }
}
</style>


// WEBPACK FOOTER //
// src/templates/content/news.vue